import { useMutation } from 'react-query';
import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum';
import { getDataFromLocalStorage } from 'src/localStorage/getDataFromLocalStorage';
import { updateCustomer } from 'src/services/napi';
import { Project } from 'src/services/napi/projects/interfaces/fetchProjects.interface';
import {
  UpdateCustomerProps,
  UseMutationInterface
} from './interfaces/useUpdateCustomer.interface';
import { useNotification } from '../../../providers/notificationsProvider';

const updateCustomerData = async ({ customerId, body }: UpdateCustomerProps) => {
  const currentProject = getDataFromLocalStorage<Project>(LocalStorageKey.CURRENT_PROJECT);

  if (!currentProject) return;
  const { _id: projectId } = currentProject;
  await updateCustomer(projectId, customerId, body);
};

export const useUpdateCustomer = ({ onError, onSuccess }: UseMutationInterface) => {
  const { notify } = useNotification();

  return useMutation((data: UpdateCustomerProps) => updateCustomerData(data), {
    onError: () => {
      notify({ message: 'something went wrong', severity: 'error' });
      if (onError) {
        onError();
      }
    },
    onSuccess: () => {
      if (onSuccess) {
        onSuccess();
      }
    }
  });
};
